import React from 'react';
import PropTypes from 'prop-types';
import ProductSale from './ProductSale';
import { t } from '../../../../../modules/infra/i18n';

const AddProducts = ({ onClick, modalOff, modalIsOn }) => (
  <div className="u-ml- u--mt- u-mb- u-text-right o-flexbox__item">
    <button
      type="button"
      className="c-btn"
      onClick={onClick}
    >
      {t('appointment:form.charge_buttons.add_products')}
    </button>
    <ProductSale close={modalOff} display-if={modalIsOn} />
  </div>
);

AddProducts.propTypes = {
  onClick: PropTypes.func.isRequired,
  modalOff: PropTypes.func.isRequired,
  modalIsOn: PropTypes.bool.isRequired,
};

export default AddProducts;
